export default __webpack_public_path__ + "static/media/cover.688f49c0.png";